export default {
    parts: [
        'container',
        'inner',
        'message',
        'ctaUnderline',
        'brandToggle',
        'brandButton',
        'brandButtonActive',
        'brandButtonInactive',
        'mobileTrigger',
        'desktopTrigger',
        'globeIcon',
        'chevronIcon'
    ],
    baseStyle: {
        container: {
            backgroundColor: 'webTheme.backgroundReverse',
            color: 'webTypo.textOnColor',
            w: '100%',
            minH: {base: '34px', lg: '32px'},
            position: 'relative',
            zIndex: 1101
        },
        inner: {
            justify: {base: 'space-between', lg: 'center'},
            align: 'center',
            maxW: 'container.xxxl',
            height: '100%',
            mx: 'auto',
            position: 'relative',
            px: {base: 4, lg: 6},
            py: {base: '5px', lg: 0}
        },
        message: {
            textStyle: 'webH4',
            color: 'webTypo.textOnColor',
            textAlign: {base: 'start', lg: 'center'},
            flex: {base: '1', lg: 'none'},
            position: {base: 'relative', lg: 'absolute'},
            left: {base: 'auto', lg: '50%'},
            transform: {base: 'none', lg: 'translateX(-50%)'}
        },
        ctaUnderline: {
            color: 'webTypo.textOnColor',
            textDecoration: 'underline'
        },
        brandToggle: {
            display: {base: 'none', lg: 'flex'},
            align: 'center',
            columnGap: 6,
            textTransform: 'uppercase',
            mr: 'auto'
        },
        brandButton: {
            display: 'inline-flex',
            alignItems: 'center'
        },
        brandButtonActive: {
            color: 'white',
            cursor: 'default'
        },
        brandButtonInactive: {
            color: 'white',
            opacity: 0.5,
            _hover: {
                opacity: 1
            }
        },
        mobileTrigger: {
            align: 'center',
            ml: 'auto',
            _hover: {cursor: 'pointer'},
            columnGap: 2
        },
        desktopTrigger: {
            align: 'center',
            ml: 'auto',
            _hover: {cursor: 'pointer'},
            columnGap: 2
        },
        globeIcon: {
            boxSize: 4,
            pointerEvents: 'none'
        },
        chevronIcon: {
            boxSize: 5,
            pointerEvents: 'none'
        }
    },
    variants: {
        light: {
            container: {
                backgroundColor: 'webTheme.backgroundPrimaryBrand',
                color: 'webTypo.textPrimary'
            },
            brandButtonActive: {
                color: 'webTypo.textPrimary'
            },
            brandButtonInactive: {
                color: 'webTypo.textPrimary',
                opacity: 0.5,
                _hover: {
                    opacity: 1
                }
            },
            message: {
                color: 'webTypo.textPrimary'
            },
            ctaUnderline: {
                color: 'webTypo.textPrimary'
            },
            globeIcon: {
                color: 'black'
            }
        }
    }
}
